import { createOption } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { GroupOption } from '@mews-commander/types';
import { ReservationContractTemplateFieldIdentifier } from '@mews-commander/data-access';

export enum TemplateFormStepFields {
    templateOptionsFields = 'templateOptionsFields',
    dataMappingFields = 'dataMappingFields',
}

export const dataMappingsMockData = [
    {
        id: '5fcc9014-60bd-4ada-9537-836f72a2f58d',
        templateId: '38a3a559-8f70-43ff-aa17-0b3d0ae3124b',
        tabId: '5',
        tabType: 'text',
        valueCategory: 'ReservationDetail',
        valueIdentifier: ReservationContractTemplateFieldIdentifier.TaxIdentifier,
    },
    {
        id: 'f95b9f29-cd46-45bf-832e-eb7ab522e1fa',
        templateId: '38a3a559-8f70-43ff-aa17-0b3d0ae3124b',
        tabId: '1',
        tabType: 'text',
        valueCategory: 'GuestProfile',
        valueIdentifier: ReservationContractTemplateFieldIdentifier.ArrivalDate,
    },
    {
        id: 'f95b9f29-cd46-45bf-832e-eb7ab522e1f1',
        templateId: '38a3a559-8f70-43ff-aa17-0b3d0ae3124b',
        tabId: '2',
        tabType: 'text',
        valueCategory: 'GuestProfile',
        valueIdentifier: ReservationContractTemplateFieldIdentifier.City,
    },
];

export const externalTemplatesMockData = [
    {
        id: '1b122e59-4e10-4f38-8aa4-7b33d027dd49',
        name: 'Long stay agreement',
        description: 'I am description.',
        serviceIds: ['58ff659a-76f0-4824-9191-ad4e00d402bc', '1cc4588d-eab7-4bea-b16f-b066013f014e'],
        status: 'UpToDate',
        docusignTemplateId: '1',
    },
];

enum DataMappingCategories {
    ReservationDetail = 'ReservationDetail',
    GuestProfile = 'GuestProfile',
    GuestAdditional = 'GuestAdditional',
    GuestAddress = 'GuestAddress',
}

const dataMappingCategoriesMap = {
    [DataMappingCategories.GuestProfile]: [
        ReservationContractTemplateFieldIdentifier.Email,
        ReservationContractTemplateFieldIdentifier.Title,
        ReservationContractTemplateFieldIdentifier.FirstName,
        ReservationContractTemplateFieldIdentifier.FirstLastName,
        ReservationContractTemplateFieldIdentifier.SecondLastName,
        ReservationContractTemplateFieldIdentifier.Nationality,
        ReservationContractTemplateFieldIdentifier.Language,
        ReservationContractTemplateFieldIdentifier.Telephone,
        ReservationContractTemplateFieldIdentifier.Sex,
        ReservationContractTemplateFieldIdentifier.DateOfBirth,
        ReservationContractTemplateFieldIdentifier.PlaceOfBirth,
    ],
    [DataMappingCategories.GuestAdditional]: [
        ReservationContractTemplateFieldIdentifier.TaxIdentifier,
        ReservationContractTemplateFieldIdentifier.CardRegistrationNumber,
        ReservationContractTemplateFieldIdentifier.Occupation,
        ReservationContractTemplateFieldIdentifier.Company,
    ],
    [DataMappingCategories.GuestAddress]: [
        ReservationContractTemplateFieldIdentifier.FullAddress,
        ReservationContractTemplateFieldIdentifier.StreetMain,
        ReservationContractTemplateFieldIdentifier.StreetAdditional,
        ReservationContractTemplateFieldIdentifier.City,
        ReservationContractTemplateFieldIdentifier.PostalCode,
        ReservationContractTemplateFieldIdentifier.Country,
        ReservationContractTemplateFieldIdentifier.StateOrProvince,
    ],
    [DataMappingCategories.ReservationDetail]: [
        ReservationContractTemplateFieldIdentifier.ReservationOwner,
        ReservationContractTemplateFieldIdentifier.Service,
        ReservationContractTemplateFieldIdentifier.SpaceCategory,
        ReservationContractTemplateFieldIdentifier.RoomNumber,
        ReservationContractTemplateFieldIdentifier.ConfirmationNumber,
        ReservationContractTemplateFieldIdentifier.ArrivalDate,
        ReservationContractTemplateFieldIdentifier.ArrivalTime,
        ReservationContractTemplateFieldIdentifier.DepartureDate,
        ReservationContractTemplateFieldIdentifier.DepartureTime,
        ReservationContractTemplateFieldIdentifier.Rate,
        ReservationContractTemplateFieldIdentifier.TotalAmount,
        ReservationContractTemplateFieldIdentifier.AverageBookableServiceRate,
        ReservationContractTemplateFieldIdentifier.AverageBookableServiceWithProductsRate,
    ],
} as const;

const TEMPLATE_CATEGORY_OPTION_LABEL_PREFIX = 'ContractTemplateTabCategoryOptionLabel';
const TEMPLATE_IDENTIFIER_OPTION_LABEL_PREFIX = 'ContractTemplateTabIdentifierOptionLabel';

export const templateDataMappingOptions: GroupOption[] = Object.entries(dataMappingCategoriesMap).map(
    ([category, identifiers]) => ({
        groupLabel: lt(`${TEMPLATE_CATEGORY_OPTION_LABEL_PREFIX}${category as DataMappingCategories}`),
        groupOptions: identifiers.map((identifier) =>
            createOption({
                label: lt(`${TEMPLATE_IDENTIFIER_OPTION_LABEL_PREFIX}${identifier}`),
                value: identifier,
            })
        ),
    })
);
